import { type ReactNode } from 'react'
import { type IconButtonProps, IconButton } from '@mui/material'

export const listItemIconClasses = {
  root: 'ListItemIcon-root',
}

export type Props = {
  testId?: string
  icon: ReactNode
  onClick?: IconButtonProps['onClick']
  disabled?: boolean
}

export function ListItemIcon(props: Props) {
  const { icon, testId = 'ListItemIcon', onClick, disabled = false } = props

  return (
    <IconButton
      disableRipple
      data-testid={testId}
      className={listItemIconClasses.root}
      onClick={onClick}
      disabled={disabled}
      size="medium"
    >
      {icon}
    </IconButton>
  )
}
